﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:ScheduleGeneratorController
 * @description
 * # ScheduleGeneratorController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('ScheduleGeneratorController', ['$uibModalInstance', '$scope', 'ScheduleGeneratorService', 'FlashService', 'Utils',
      function ($uibModalInstance, $scope, ScheduleGeneratorService, FlashService, Utils) {

      $scope.generate = function () {

          var loading = Utils.OpenModal('', 'ng1/src/scheduleGenerator/scheduleGeneratingPopup.html', null, null, null, null, true);

          $uibModalInstance.dismiss();
          ScheduleGeneratorService.GenerateSchedule().then(function (result) {
              loading.dismiss();

              if (result.success) {
                  FlashService.Success(result.data.message);
              }
          });
      };

      $scope.dismiss = function () {
          $uibModalInstance.dismiss();
      };
  }]);